import { Submission } from '@sky-distribution/gp-onboarding-policy-service';
import { Contact } from '@sky-distribution/adapter-core-pc-rest-interfaces/core/rest/v2/Policy.type';

export const getEngineerDataSubmission = (submission: Submission, engineerData: Contact): Submission => ({
  ...submission,
  baseData: {
    ...submission?.baseData,
    accountHolder: {
      ...submission?.baseData?.accountHolder,
      person: engineerData,
    },
  },
});
